import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as libraries from '../../libraries'

export const RESOURCE = {
  payload: {
    description:
      'A facility providing research materials, data, and academic resources.',
    dimension: libraries.RESOURCE.payload,
    level: 0,
    name: 'Library',
    partialId: PartialId.Standard.create('lib'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
